import { render, staticRenderFns } from "./Magazines.vue?vue&type=template&id=4282d08b&scoped=true&"
import script from "./Magazines.vue?vue&type=script&lang=js&"
export * from "./Magazines.vue?vue&type=script&lang=js&"
import style0 from "./Magazines.vue?vue&type=style&index=0&id=4282d08b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4282d08b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCard,VSlideGroup,VSlideItem})
